import React, { useState } from 'react';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';

import styles from './CustomInsightCreationModal.module.css';
import Select from '../SystemSettings/components/Controls/Select/Select';
import Label from '../SystemSettings/components/Controls/Label/Label';

const CustomInsightCreationModal = ({ onCreate, onCancel, staticInsightsDropdownOptions }) => {
    const [selectedStaticInsight, setSelectedStaticInsight] = useState(staticInsightsDropdownOptions[0].value);

    const onCreateClick = () => {
        onCreate(selectedStaticInsight);
    };

    const onSelectInsightChange = (id, val) => {
        setSelectedStaticInsight(val);
    };

    return (
        <Modal id={styles.customInsightCreationModal} show={true} backdrop="static">
            <Modal.Header>
                <Modal.Title>New Custom Insight</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.selectedTypeContent}>
                        <>
                            <Label value="Select Existing Insight" />
                            <Select
                                value={selectedStaticInsight}
                                changed={onSelectInsightChange}
                                searchable={true}
                                options={staticInsightsDropdownOptions}
                                wide
                            />
                        </>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button bsStyle="success" onClick={onCreateClick}>
                        Create
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomInsightCreationModal;
